import { useTheme } from '@/components/theme/ThemeProvider';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * 앱 전역 토스트. main.tsx 의 ThemeProvider 안에서 한 번 마운트한다.
 * 사용처: `import { toast } from 'sonner'` 후 toast.success/error/message 호출.
 */
export function Toaster(props: ToasterProps) {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        },
      }}
      {...props}
    />
  );
}
